// extracted by mini-css-extract-plugin
module.exports = {"table":"Lamps_table__kOpCk","checkboxGroup":"Lamps_checkboxGroup__2T5AD","groups":"Lamps_groups__lWTJq","editButton":"Lamps_editButton__tcsPl"};